import React, { ReactNode } from 'react'
import { Container, Footer, FromLeft, FromRight } from './styles'
import { MarkdownFormattedText } from './MarkdownFormattedText'
import { PlainText } from './PlainText'
import { UserAvatar } from './UserAvatar'
import { UserName } from './UserName'
import { ErrorIndicator } from './ErrorIndicator'

export * from './Loader'

type MessageProps = {
  children: ReactNode
}

const MessageRootLeft = ({ children }: MessageProps): JSX.Element => {
  return <Container alignSelf="flex-start">{children}</Container>
}

const MessageRootRight = ({ children }: MessageProps): JSX.Element => {
  return <Container alignSelf="flex-end">{children}</Container>
}

export const Message = {
  RootLeft: MessageRootLeft,
  RootRight: MessageRootRight,
  MarkdownFormattedText,
  Footer,
  FromLeft,
  FromRight,
  PlainText,
  UserAvatar,
  ErrorIndicator,
  UserName
}
